import React, { useEffect, useRef } from "react";
import "./Alert.scss";

import Check from "../../SVG/Check";
import ExclamationMark from "../../SVG/ExclamationMark";
import Close from "../../SVG/Close";
import { MessageType, ALERT_TIMEOUT } from "../../../store/message";

interface Props {
  type: MessageType.success | MessageType.failed;
  message: string | null;
  onClear: () => void;
}

const TRANSITION_TIMEOUT = 300;

const Alert: React.FC<Props> = (props) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  const alertSign = props.type === MessageType.failed ? <ExclamationMark /> : <Check />;

  const unmountAlert = (alertDiv: HTMLDivElement) => {
    alertDiv.classList.remove("alertMounted");
    alertDiv.classList.add("alertUnmounted");
  };

  const clearAlert = () => {
    const alertDiv = nodeRef.current;
    if (alertDiv) {
      unmountAlert(alertDiv);
    }

    setTimeout(() => {
      props.onClear();
    }, TRANSITION_TIMEOUT);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    const alertDiv = nodeRef.current;

    if (alertDiv) {
      alertDiv.classList.remove("alertMounting");
      alertDiv.classList.add("alertMounted");

      timer = setTimeout(() => {
        unmountAlert(alertDiv);
      }, ALERT_TIMEOUT - TRANSITION_TIMEOUT);
    }

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      ref={nodeRef}
      className={`alert alertMounting ${props.type === MessageType.failed ? "border-red-800" : "border-blue-600"}`}
    >
      <div className="flex flex-row items-center">
        <div className={`rounded-full p-1 ${props.type === MessageType.failed ? "bg-red-500" : "bg-blue-500"}`}>
          {alertSign}
        </div>
        <p className="text-xs defaultText ml-3">{props.message || "An error occured"}</p>
      </div>

      <div onClick={clearAlert} className="cursor-pointer ml-2">
        <Close />
      </div>
    </div>
  );
};

export default Alert;
